export default function() {
    (function($) {
        $(function() {
            const sideNavColumn = document.querySelector(".side-nav-column");
            const sideNav = document.querySelector(".side-nav");

            if (!sideNavColumn && !sideNav) return;

            const sideNavHeight = sideNav.getBoundingClientRect().height;
            const sideNavColumnHeight = sideNavColumn.getBoundingClientRect()
                .height;
            const fixPoint = 140;

            if (sideNavHeight === sideNavColumnHeight) return;

            let sideNavColumnTop = sideNavColumn.getBoundingClientRect().top;
            let sideNavColumnBottom = sideNavColumn.getBoundingClientRect()
                .bottom;

            function fixSideNav() {
                if (sideNavColumnTop <= fixPoint) {
                    if (fixPoint + sideNavHeight >= sideNavColumnBottom) {
                        $(sideNav).removeClass("lg:fixed");
                        $(sideNav).addClass("lg:absolute pin-b");
                    } else {
                        $(sideNav).removeClass("lg:absolute pin-b");
                        $(sideNav).addClass("lg:fixed");
                    }
                } else {
                    $(sideNav).removeClass("lg:fixed lg:absolue pin-b");
                }
            }

            fixSideNav();

            $(window).on("scroll", function() {
                sideNavColumnTop = sideNavColumn.getBoundingClientRect().top;
                sideNavColumnBottom = sideNavColumn.getBoundingClientRect()
                    .bottom;

                fixSideNav();
            });
        });
    })(jQuery);
}



// WEBPACK FOOTER //
// ./src/js/partials/side-nav.js